import { get } from "helpers/api_helper"

const formattedMatchIdPattern = /^#?FM(\d+)$/i
const numericSearchPattern = /^\d+$/

const formatMatchIdSearch = value =>
  `FM${String(value).padStart(5, "0")}`

const normalizeFormattedMatchIdSearch = search => {
  const normalizedSearch = String(search || "").trim()
  const formattedMatch = normalizedSearch.match(formattedMatchIdPattern)

  if (formattedMatch) {
    return formatMatchIdSearch(formattedMatch[1])
  }

  return normalizedSearch
}

const buildFriendlyMatchesUrl = params =>
  `/friendly-matches?${new URLSearchParams(params).toString()}`

const hasNoResults = response => {
  const data = response?.data
  if (data?.totalResults !== undefined && data?.totalResults !== null) {
    return Number(data.totalResults) === 0
  }

  if (Array.isArray(data?.results)) {
    return data.results.length === 0
  }

  return false
}

export const getFriendlyMatches = async payload => {
  let response
  const params = {}

  Object.assign(params, payload?.payload[0]);
  Object.assign(params, payload?.payload[1]);

  const rawSearch = String(params.search || "").trim()
  const normalizedSearch = normalizeFormattedMatchIdSearch(rawSearch)
  if (normalizedSearch) params.search = normalizedSearch

  try {
    response = await get(buildFriendlyMatchesUrl(params))

    if (
      rawSearch &&
      numericSearchPattern.test(rawSearch) &&
      hasNoResults(response)
    ) {
      response = await get(
        buildFriendlyMatchesUrl({
          ...params,
          search: formatMatchIdSearch(rawSearch),
        })
      )
    }
  } catch (error) {
    throw error
  }
  return response
}

export const getFriendlyMatch = async payload => {
  let response
  try {
    response = await get(`/friendly-matches/${payload?.payload[0]}`)
  } catch (error) {
    throw error
  }
  return response
}
